import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import * as Sentry from '@sentry/angular';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

const TmPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e6fff2',
      100: '#b3ffe0',
      200: '#80ffcd',
      300: '#4dffba',
      400: '#26f59d',
      500: '#09DE74',
      600: '#07b860',
      700: '#05914b',
      800: '#046b37',
      900: '#024523',
      950: '#012814',
    },
    colorScheme: {
      light: {
        primary: {
          contrastColor: '#053037',
        },
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: TmPreset,
        options: {
          darkModeSelector: false,
        },
      },
      translation: {
        passwordPrompt: 'Digite uma senha',
        weak: 'Fraca',
        medium: 'Média',
        strong: 'Forte',
      },
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({ showDialog: false }),
    },
  ],
};
